import React from 'react';
import EventPageTemplate from './EventPageTemplate';
import { eventData } from '../data/eventContent';

const VereenigingenPage: React.FC = () => {
  return <EventPageTemplate {...eventData['verenigingen']} />;
};

export default VereenigingenPage;
